export default "__VITE_ASSET__D17rn1e7__"